// redux/actionDispatcher/categoryModalDispatcher.js
export const showAddAttributeModal = () => {
    return {
      type: "SHOW_ADD_CATEGORY_MODAL",
    };
  };
  
  export const hideAddAttributeModal = () => {
    return {
      type: "HIDE_ADD_CATEGORY_MODAL",
    };
  };
  